import { render, staticRenderFns } from "./Area9.vue?vue&type=template&id=65e7543f&scoped=true&"
import script from "./Area9.vue?vue&type=script&lang=js&"
export * from "./Area9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7543f",
  null
  
)

export default component.exports